import * as React from "react";
import { cn } from "@/lib/utils";

type MessageProps = React.ComponentProps<"div"> & {
  from: "assistant" | "user";
};

function Message({ from, className, ...props }: MessageProps) {
  return (
    <div
      data-slot="message"
      data-from={from}
      className={cn(
        "group flex w-full items-start gap-3",
        from === "user" && "justify-end",
        className,
      )}
      {...props}
    />
  );
}

function MessageContent({
  from,
  className,
  ...props
}: React.ComponentProps<"div"> & { from: "assistant" | "user" }) {
  return (
    <div
      data-slot="message-content"
      className={cn(
        "max-w-[760px] rounded-md px-3 py-2.5 text-sm leading-6",
        from === "user"
          ? "bg-[#F5F5F5] text-[#171717]"
          : "border bg-[#FAFAFA] text-[#171717]",
        className,
      )}
      {...props}
    />
  );
}

export { Message, MessageContent };
